/**
 * <wild-purchase-options>: one-time purchase or a subscription for a product form
 * (snippets/wild-purchase-options). Keeps the form's hidden selling_plan field, the open frequency
 * choices and the displayed price in step with what the customer picks.
 */
class WildPurchaseOptions extends HTMLElement {
  connectedCallback() {
    this.field = this.querySelector('input[name="selling_plan"]');
    // Every price display the choice drives (e.g. the product price and the sticky bar), each with its original markup.
    const selector = this.dataset.priceSelector;
    this.priceTargets = selector
      ? [...document.querySelectorAll(selector)].map((target) => ({
          target,
          original: [...target.childNodes].map((node) => node.cloneNode(true)),
        }))
      : [];
    this.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    const choice = this.querySelector('.wild-purchase__choice:checked');
    const group = choice?.dataset.group || '';

    // Only the chosen subscription shows its delivery frequencies.
    for (const panel of this.querySelectorAll('[data-plans-for]')) {
      panel.hidden = panel.dataset.plansFor !== group;
    }

    const plan = group ? this.querySelector(`[data-plans-for="${CSS.escape(group)}"] input:checked`) : null;
    this.field.value = plan ? plan.value : '';
    this.field.disabled = !plan;
    this.toggleAttribute('data-subscribed', Boolean(plan));

    if (plan) this.setPlanPrice(choice.closest('.wild-purchase__card')?.querySelector('[data-plan-price]'), plan);
    this.renderPrice(plan);
  }

  /** Price markup: the regular price struck through, then the plan price. Built as nodes, not HTML. */
  priceNodes(plan) {
    const nodes = [];
    if (plan.dataset.compare) {
      const compare = document.createElement('s');
      compare.className = 'wild-price__compare';
      compare.append(this.hidden(this.dataset.labelRegular), plan.dataset.compare);
      nodes.push(compare, ' ');
    }
    const now = document.createElement('bdi');
    now.append(this.hidden(this.dataset.labelPlan), plan.dataset.price);
    nodes.push(now);
    return nodes;
  }

  hidden(text) {
    const span = document.createElement('span');
    span.className = 'visually-hidden';
    span.textContent = `${text} `;
    return span;
  }

  setPlanPrice(target, plan) {
    if (target) target.replaceChildren(...this.priceNodes(plan));
  }

  renderPrice(plan) {
    for (const { target, original } of this.priceTargets) {
      target.replaceChildren(...(plan ? this.priceNodes(plan) : original.map((node) => node.cloneNode(true))));
    }
  }
}

if (!customElements.get('wild-purchase-options')) {
  customElements.define('wild-purchase-options', WildPurchaseOptions);
}
